import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepCoApplicantAddress: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <ApplicationField product={Product.Loan} field={Fields.CoApplicantAddressOne} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.CoApplicantAddressTwo} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.CoApplicantZipcode} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.CoApplicantCity} onEnter={props.onEnter} />
    <ApplicationField product={Product.Loan} field={Fields.CoApplicantState} onEnter={props.onEnter} />
  </Wrapper>
)

export default StepbystepApplicationStepCoApplicantAddress
